import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateWorkHistoryGet } from "#candidate/services/api"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { TableMain } from "#core/components/table-main/TableMain"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { Box } from "@mui/material"
import { useMemo } from "react"

export default function CandidateWorkHistory({ autoFetch }) {
	const { candidateId, reloadFile: reload } = useCandidateRedux()
	const params = useMemo(() => ({ id: candidateId }), [candidateId])
	const { data, loading, error } = useApi(candidateWorkHistoryGet, {
		params,
		autoFetch,
		reload,
	})

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	return (
		<Box
			sx={{
				display: "flex",
				flexWrap: "wrap",
				gap: 2,
				padding: 2,
			}}
		>
			<TableMain
				data={data?.data || []}
				items={[
					{ name: "company", label: "Compañía" },
					{ name: "activities_performed", label: "Actividades Realizadas" },
					{ name: "reason_for_leaving", label: "Razón para dejar el empleo" },
					{ name: "employment_duration", label: "Duración del Empleo" },
				]}
			/>
		</Box>
	)
}
